module.exports = __webpack_public_path__ + "img/gjng2920_1.0fc07572.svg";